import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={38}
    height={39}
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.246 18.566a.88.88 0 0 1-.613-.25l-3.276-3.21a.843.843 0 0 1 0-1.201.886.886 0 0 1 1.227 0l2.662 2.608 5.95-5.839a.886.886 0 0 1 1.227 0 .843.843 0 0 1 0 1.202l-6.563 6.43a.88.88 0 0 1-.614.25'
      fill='white'
    />
  </svg>
);
export default SVGComponent;
